import { Box } from '@wix/design-system';
import { CollapseList } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React, { useEffect, useMemo, useState } from 'react';
import { initialPageIdAtom, scrollerNodeRefAtom } from '../atoms/session-atoms';
import { A11yCardWrapper } from '../components/wizard-content/content-results/card-groups/a11y-card-wrapper/a11y-card-wrapper';
import { CollapseActionsProvider, ItemScopeProvider } from '../components/wizard-content/content-results/card-groups/lists/context/collapse-actions-context';
import { ManualTasksCard } from '../components/wizard-content/content-results/card-groups/manual-tasks-card';
import { usePanelStateAtom } from '../hooks/rules-state';
export const CardsIssueList = () => {
  const {
    getPagesData
  } = usePanelStateAtom();
  const parentRef = useAtomValue(scrollerNodeRefAtom);
  const initialPageId = useAtomValue(initialPageIdAtom);
  const pagesData = getPagesData();
  const [openItems, setOpenItems] = useState(new Set([]));
  const sectionMap = useMemo(() => {
    const map = new Map();
    pagesData.forEach((_ref, pageId) => {
      var _map$get;
      let {
        dividerTitle
      } = _ref;
      if (!map.has(dividerTitle)) {
        map.set(dividerTitle, []);
      }
      (_map$get = map.get(dividerTitle)) == null || _map$get.push(pageId);
    });
    return map;
  }, [pagesData]);
  useEffect(() => {
    if (initialPageId && pagesData.has(initialPageId)) {
      const pageData = pagesData.get(initialPageId);
      if (pageData != null && pageData.dividerTitle) {
        setOpenItems(new Set([pageData.dividerTitle]));
      }
    }
  }, [initialPageId, pagesData]);
  const cardGroups = useMemo(() => {
    return Array.from(sectionMap.entries()).map(_ref2 => {
      let [dividerTitle, pageIds] = _ref2;
      const isCardOpen = openItems.has(dividerTitle);
      return /*#__PURE__*/React.createElement(ItemScopeProvider, {
        id: dividerTitle,
        key: dividerTitle
      }, /*#__PURE__*/React.createElement(A11yCardWrapper, {
        cardTitle: dividerTitle,
        isCardOpen: isCardOpen,
        pageIds: pageIds
      }));
    });
  }, [openItems, sectionMap]);
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    direction: "vertical",
    paddingLeft: "16px",
    paddingRight: "16px"
  }, /*#__PURE__*/React.createElement(CollapseActionsProvider, {
    setOpenItems: setOpenItems
  }, /*#__PURE__*/React.createElement(CollapseList, {
    autoScroll: true,
    openItems: openItems,
    scrollContainerRef: parentRef ?? undefined,
    setOpenItems: setOpenItems,
    showDividers: false
  }, cardGroups, /*#__PURE__*/React.createElement(ManualTasksCard, null))));
};
//# sourceMappingURL=cards-issue-list.js.map